module.exports = __webpack_public_path__ + "img/brazillian_helicopter_pilot.83ee5ae7.jpg";